export const USER_TYPES = {
  SYSTEM_ADMIN: "system_admin",
  STAFF: "staff",
  BUSINESS_ADMIN: "business_admin",
  CLIENT: "client",
  MASTER_ADMIN: "master_admin",
};
